import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";
import { clearAnalyticsUser } from "@/client/libs/analytics";
import { queryClient, resetResumeQueries } from "@/client/libs/query-client";
import { useAiStore } from "@/client/stores/ai";
import { useAuthStore } from "@/client/stores/auth";

export const logout = () => axios.post("/auth/logout");

export const useLogout = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: logoutFn,
  } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearAnalyticsUser();
      useAiStore.getState().unbindUser();
      setUser(null);
      queryClient.setQueryData(["user"], null);
      resetResumeQueries();
    },
    onError: () => {
      clearAnalyticsUser();
      useAiStore.getState().unbindUser();
      setUser(null);
      queryClient.setQueryData(["user"], null);
      resetResumeQueries();
    },
  });

  return { logout: logoutFn, loading, error };
};
